import { useController } from 'react-hook-form';
import { ProjectTimeZone } from '../../ScheduleCampaignModal/ScheduleCampaignForm/ProjectTimeZone';
import { StartDateAndTime } from '../../ScheduleCampaignModal/ScheduleCampaignForm/StartDateAndTime';
import { EndEligibilitySchedule } from './EndEligibilitySchedule';

const ScheduleTypePlaceholder = () => {
  // Workaround to enable form value without rendering controls in SendWithRespectTo
  useController({
    name: 'scheduleType',
  });

  return <></>;
};

const EndAfterPlaceholder = () => {
  // Workaround to enable form value without rendering controls in EndRecurrenceAfter
  useController({
    name: 'endAfterUnit',
  });

  return <></>;
};

export const DisplayEligibilityCampaignForm = ({ withStart = true }: { withStart?: boolean }) => {
  return (
    <>
      {withStart && <StartDateAndTime />}
      <EndEligibilitySchedule />
      <EndAfterPlaceholder />
      {/* <SendWithRespectTo /> */}
      <ScheduleTypePlaceholder />
      <ProjectTimeZone />
    </>
  );
};
